import React, { useEffect, useState } from 'react';
import css from './SectionBoosting.css';
import { FormattedMessage } from '../../../../util/reactIntl';
import {
    EditPencilIcon,
    IconBoost3xL,
    IconCheckmark,
    IconEyeHideS,
    IconLockL,
    SpaceshipIcon,
} from '../../../../icons';
import { Button, IconSpinner } from '../../../../components';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import {
    BOOSTING_CH,
    BOOSTING_DE,
    LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
} from '../../../../util/urlHelpers';
import { getListingsImpressions } from '../../../../util/api';
import { useRequest } from '../../../../hooks/useRequest';

const SectionBoosting = ({
    currentUser: {
        attributes: {
            profile: {
                publicData: { country },
            },
        },
    },
    currentListing,
    listingPublished,
    editParams,
    history,
    isOwnListing,
}) => {
    const [impressions, setImpressions] = useState(null);

    const {
        id: { uuid: listingId },
        attributes: {
            metadata,
            publicData: { viewsNum_total: viewsNum, favoredBy = [] },
        },
    } = currentListing;

    const { anonymousListing: anonymousPackagePurchased, socialBoost } = metadata || {};

    const favoriteNum = favoredBy.length;
    const packagesNum = [anonymousPackagePurchased, socialBoost].filter(s => !!s).length;
    const noData = packagesNum === 0;
    const skipSectionRender = isOwnListing && !listingPublished && noData;

    const idToFetchimpressions = skipSectionRender ? null : listingId;

    const countryBoostingConfig = {
        CH: BOOSTING_CH,
        DE: BOOSTING_DE,
    };

    const boostingPath = (country && countryBoostingConfig[country]) || BOOSTING_CH;

    const navigateToPackagesPage = () =>
        history.push(
            createResourceLocatorString(
                'EditListingPage',
                routeConfiguration(),
                {
                    ...editParams,
                    type: LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
                    tab: boostingPath,
                },
                {}
            )
        );

    const { loading, request } = useRequest();

    useEffect(() => {
        if (idToFetchimpressions) {
            request(
                async () => await getListingsImpressions(idToFetchimpressions),
                data => setImpressions(data?.impressionsNum || 0)
            );
        }
    }, [idToFetchimpressions]);

    if (skipSectionRender) return null;

    return (
        <section className={css.root}>
            <h4 className={css.title}>Statistiken & Pakete</h4>
            <p className={css.note}>
                <IconEyeHideS />
                <span>Nur für dich sichtbar</span>
            </p>
            <div className={css.statistics}>
                {loading ? (
                    <IconSpinner />
                ) : (
                    <div>
                        <p className={css.subTitle}>Impressionen</p>
                        {impressions || 0}
                    </div>
                )}
                <div>
                    <p className={css.subTitle}>Ansichten</p>
                    {viewsNum || 0}
                </div>
                <div>
                    <p className={css.subTitle}>Favorisiert</p>
                    {favoriteNum}
                </div>
            </div>
            {noData ? (
                <>
                    <p className={css.noData}>
                        <SpaceshipIcon />
                        <span>Keine Pakete aktiviert</span>
                    </p>
                    <aside>
                        <p>Verfügbare Pakete:</p>
                        <div className={css.advantages}>
                            <p>
                                <IconBoost3xL />
                                <span>Social Boost</span>
                            </p>
                            <p>
                                <IconLockL />
                                <span>Anonymes Inserat</span>
                            </p>
                        </div>
                    </aside>
                    <Button
                        type="button"
                        className={css.addPackageButton}
                        onClick={() => navigateToPackagesPage()}
                    >
                        Zusatzpaket hinzufügen
                    </Button>
                </>
            ) : (
                <div className={css.packagesAvailable} onClick={() => navigateToPackagesPage()}>
                    <p>
                        <SpaceshipIcon />
                        <FormattedMessage
                            id={`SectionBoosting.activated-${
                                packagesNum === 1 ? 'package' : 'packages'
                            }`}
                        />
                        <EditPencilIcon />
                    </p>
                </div>
            )}
        </section>
    );
};

export default SectionBoosting;
